const ExampleItem = function(fullName, phone, email, product) {
    this.fullName = fullName;
    this.phone = phone;
    this.email = email;
    this.product = product;
}

const testData = [
    new ExampleItem('Мария Иванова', parseInt('+375295008043'), 'ivamovaMar@email.com', 'course-php'),
    new ExampleItem('Сергей Петров', parseInt('+375336548924'), 'petrovSERg@email.com', 'course-wordpress'),
    new ExampleItem('Татьяна Пупкина', parseInt('+375205055050'), 'pupkTan@email.com', 'course-html'),
    new ExampleItem('Ольга Сергеева', parseInt('+375293098760'), 'sergeyeva@email.com', 'course-vue'),
    new ExampleItem('Дмитрий Долгий', parseInt('+375336543342'), 'DmDol@email.com', 'course-js'),
    new ExampleItem('Эраст Фандорин', parseInt('+375336786984'), 'erastFondorin@email.com', 'course-php'),
    new ExampleItem('Николай Светлаков', parseInt('+375337650099'), 'svetlakNick@email.com', 'course-js'),
    new ExampleItem('Екатерина Великая', parseInt('+375290009988'), 'velikayaEkater@email.com', 'course-vue'),
]

function getRandomIndex(max) {
    return Math.floor(Math.random()* max)
}

function testRequest() {
    let randomIndex = getRandomIndex(testData.length);
    return (testData[randomIndex]);
}

export {testRequest}

